const shopVelocities = [
  { value: 'medium moving goods', label: 'Medium velocity goods' },
  { value: 'slow moving goods', label: 'Slow-moving goods' },
  { value: 'fast moving goods', label: 'Fast-moving goods' },
];

export default shopVelocities;
